<template>
  <span :class="['text-secondary', {
    'text-success': value >= 0,
    'text-danger': value < 0,
  }]"> {{ value.toFixed(precision) }} {{ legend }}</span>
</template>
<script>
export default {
  props: {
    value: { type: [Number], default: null },
    legend: { type: [String], default: '' },
    precision: { type: [Number], default: 1 },
  },
  computed: {
  }
};
</script>
<style lang=" scss"></style>
